module.exports = {"TXTWCL_In_Play":{"id":"TXTWCL_In_Play","defaultMessage":"In-Play"}}